import { render } from "./logoEdit.vue?vue&type=template&id=0ff2eead&scoped=true"
import script from "./logoEdit.vue?vue&type=script&lang=js"
export * from "./logoEdit.vue?vue&type=script&lang=js"

import "./logoEdit.vue?vue&type=style&index=0&id=0ff2eead&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff2eead"]])

export default __exports__